import { useState } from "react";
import { Mail, Check } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function NewsletterForm({ source = "inline", dark = false }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, done: false, msg: "", error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, done: false, msg: "", error: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setState({ loading: false, done: true, msg: data.message, error: "" });
    } catch (err) {
      setState({ loading: false, done: false, msg: "", error: formatApiError(err.response?.data?.detail) });
    }
  };

  if (state.done) {
    return (
      <div className={`rounded-2xl p-5 flex items-center gap-3 ${dark ? "bg-white/10 text-cream" : "bg-teal/10 text-teal"}`} data-testid="newsletter-success">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white shrink-0"><Check className="h-5 w-5" /></span>
        <p className="text-[15px] font-medium">{state.msg}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full" data-testid="newsletter-form">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Mail className={`absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 ${dark ? "text-rose" : "text-mutedplum"}`} />
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address" data-testid="newsletter-email-input"
            className={`w-full rounded-full pl-12 pr-4 py-3.5 text-[15px] outline-none border-2 transition-colors
              ${dark ? "bg-white/95 border-transparent focus:border-rose text-plum-ink" : "bg-white border-rose/50 focus:border-teal text-plum-ink"}`}
          />
        </div>
        <button type="submit" disabled={state.loading} data-testid="newsletter-submit"
          className="rounded-full bg-teal px-7 py-3.5 font-semibold text-white hover:bg-teal-dark transition-colors disabled:opacity-60 whitespace-nowrap">
          {state.loading ? "Sending…" : "Subscribe"}
        </button>
      </div>
      {state.error && <p className="mt-2 text-sm text-red-500" data-testid="newsletter-error">{state.error}</p>}
      <p className={`mt-2 text-xs ${dark ? "text-cream/70" : "text-mutedplum"}`}>Double opt-in. No spam, unsubscribe anytime.</p>
    </form>
  );
}
